module.exports = __webpack_public_path__ + "media/customizations/bedfordlife/logo-cc21fac91fb56eff8fe1a33a97eb7854.png";